module.exports = __webpack_public_path__ + "img/brittleLava.70d9e55c.jpg";